import React, {Component} from 'react';
import Grid from "@material-ui/core/Grid";
import './style.scss';
import Button from "@material-ui/core/Button";
import Joi from "joi-browser";
import {toast} from "react-toastify";
import Hidden from "@material-ui/core/Hidden";

class NewsLetter extends Component{

    state = {
        email: '',
        error: {},
    };

    schema = {
        email: Joi.string()
            .required()
            .email()
            .error(errors => {
                errors.forEach(err => {
                    switch (err.type) {
                        case 'string.email':
                            err.message = 'Email Must be Email Format';
                            break;
                        case 'any.required':
                            err.message = 'Email is Requared';
                            break;
                        default:
                            break;
                    }
                });
                return errors;
            }),
    };

    changeHandler = event => {
        const error = { ...this.state.error };
        const errorMassage = this.validationProperty(event);
        if (errorMassage) {
            error[event.target.name] = errorMassage;
        } else {
            delete error[event.target.name];
        }
        this.setState({
            [event.target.name]: event.target.value,
            error,
        });
    };


    validationProperty = event => {
        const Obj = { [event.target.name]: event.target.value };
        const schema = { [event.target.name]: this.schema[event.target.name] };
        const { error } = Joi.validate(Obj, schema);
        return error ? error.details[0].message : null;
    };

    validate = () => {
        const options = { abortEarly: false };
        const form = {
            email: this.state.email,
        };
        const { error } = Joi.validate(form, this.schema, options);
        if (!error) return null;

        const errors = {};
        for (const item of error.details) errors[item.path[0]] = item.message;
        return errors;
    };

    submitHandler = event => {
        event.preventDefault();
        const error = this.validate();
        this.setState({
            error: error || {},
        });
        if (!error) {
            toast.success('Successfully Sent!');
            this.setState({
                email: '',
            })
        }
    };

    render() {
        const {email } = this.state;
        const {className} = this.props;
        return (
            <Grid className={`newsLetter ${className}`}>
                <Grid container className="container" spacing={4}>
                    <Hidden smDown><Grid item xs={12} md={2}/></Hidden>
                    <Grid item xs={12} md={8}>
                        <Grid className="content">
                            <strong>NewsLetter</strong>
                            <h2>OneTwoPay<span>Updates</span></h2>
                            <p>Over time, we will add to our list of services. Sign up here to be notified when we
                                launch new features and services.</p>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container className="container" spacing={4}>
                    <Hidden smDown><Grid item xs={12} md={2}/></Hidden>
                    <Grid item xs={12} md={8}>
                        <Grid className="nwslRight">
                            <h5>Subscribe for updates</h5>
                            <form onSubmit={this.submitHandler}>
                                <input
                                    name="email"
                                    onChange={this.changeHandler}
                                    type="text"
                                    value={email}
                                    placeholder="Your email"/>
                                <p className="error">{this.state.error.email ? this.state.error.email : ''}</p>
                                <Button type="submit">Subscribe</Button>
                            </form>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default NewsLetter;